import { MobilfunkStudienEntry } from '@/model/mobilfunk-studien';

import { DataFetcher } from './fetcher/DataFetcher/index.ts';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface MobilfunkStudienSearchParams extends AbstractSearchParams {
  health_damage?: string;
  journal_name?: string;
  year?: string;
  language?: string;
  category?: string;
}

export class MobilfunkStudienRepository extends RepositoryNocoDbBase<
  MobilfunkStudienEntry,
  MobilfunkStudienSearchParams
> {
  protected readonly TABLE_NAME = 'mobilfunkstudien';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD = 'date_of_publication';

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS: (keyof MobilfunkStudienEntry)[] = [
    'health_damage',
    'journal_name',
    'year',
    'language',
    'category'
  ];

  protected readonly SEARCH_FIELDS: (keyof MobilfunkStudienEntry)[] = [
    'abstract',
    'title',
    'health_damage',
    'journal_name',
    'category'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
